<a routerLink="/search" aria-label="Shop products with free shipping over ${{free_shipping_threshold}}">
  <span>Free shipping over ${{free_shipping_threshold}}</span>
  <span class="divider" aria-hidden="true"></span>
  <span>Fresh activewear drops now live</span>
</a>
